import store from '@/store';
import { Product } from '@/consts/product';

const microApps = [
  {
    name: 'intelligent-marketing',
    entry: process.env.SUB_APP_INTELLIGENT_MARKETING,
    activeRule: '/intelligent-marketing',
    meta: {
      title: '云察',
      productId: Product.YUNCHA,
    },
  },
  {
    name: 'brand-mp',
    entry: process.env.SUB_APP_BRANDMP,
    activeRule: '/brand-mp',
    meta: {
      title: '品牌小程序',
      productId: Product.BRAND,
    },
  },
  {
    name: 'retail-mp',
    entry: process.env.SUB_APP_RETAILMP,
    activeRule: '/retail-mp',
    meta: {
      title: '零售小程序',
      productId: Product.RETAIL,
    },
  },
  {
    name: 'rhino',
    entry: process.env.SUB_APP_RHINO,
    activeRule: '/rhino',
    meta: {
      title: '巨犀',
      productId: Product.RHINO,
    },
  },
  {
    name: 'app-center',
    entry: process.env.SUB_APP_APPCENTER,
    activeRule: '/app-center',
    meta: {
      title: '应用中心',
    },
  },
  {
    name: 'retail',
    entry: process.env.RETAIL,
    activeRule: '/retail',
    meta: {
      title: '自定义页面',
    },
  },
  {
    name: 'dashboard',
    entry: process.env.SUB_APP_DASHBOARD,
    activeRule: '/dashboard',
    meta: {
      title: '全域数据',
    },
  },
];

const apps = microApps.map(item => ({
  ...item,
  container: '#subapp-root', // 子应用挂载的div
  props: {
    routerBase: item.activeRule, // 下发基础路由
  },
}));

export function getAppByPath(path) {
  const app = apps.find(({ activeRule }) => path.startsWith(activeRule));

  if (!app) {
    return;
  }

  const {
    props,
    ...config
  } = app;
  return {
    ...config,
    props: {
      ...props,
      token: store.state.user.token,
      functionList: store.state.user.functionList,
      theme: localStorage.getItem('theme') || 'light',
    },
  };
}

export const getAppByProductId = productId => apps.find(app => app.meta.productId === productId);

export function isUnderSameMicroApp(...paths) {
  const microAppPaths = paths.map(path => path.replace(/^\/([^/]+)[^]*/, '$1'));
  return (new Set(microAppPaths)).size === 1;
}

export function updateAppTitle(productText) {
  apps.forEach((app) => {
    app.meta.title = productText[app.meta.productId];
  });
}

export default apps;
